import React, { Component } from 'react'

import { Modal } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'
import * as ajax from '../Utilities/ajax'
import Auth from '../Utilities/Auth'

export default class DisableUser extends Component<any> {
  state = {
    loading: false,
    show: true,
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open)
      this.setState({ loading: false, show: true, })
  }

  onModalConfirm = async () => {
    this.setState({ loading: true })
    if (this.props.open.curStatus === false || this.props.open.curStatus === true) {
      let data = {
        userId: this.props.open.val,
        is_disabled: this.props.open.curStatus
      }
      await ajax.put("/video/status", data).then(result => {
        this.props.callback()
      }).catch(e => {
        console.log(e)
        this.setState({ loading: false })
      })
    } else {
      let data = {
        id:this.props.open.val,
        user: Auth.getUserName()
      }
      await ajax.post("/video/delete/video", data).then(result => { 
        this.props.callback()  
      }).catch(e => { 
        console.log(e)
        this.setState({ loading: false })
      })
      
    }
  }

  render() {
    // console.log(this.state)
    let curStatus = this.props.open.curStatus
    return (
      <Modal show={this.props.open.show}>
        <Modal.Header>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {`Are you sure you want to ${curStatus && curStatus !== true ? "delete" : (curStatus ? "enable" : "disable")} this item?`}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle={(curStatus === true ? "success" : "danger")}
            loading={this.state.loading}
            onClick={this.onModalConfirm}
            disabled={false}>
            {this.state.loading ? 'Please wait' : `${curStatus && curStatus !== true ? "Delete" : (curStatus ? "Enable" : "Disable")}`}
          </Button>
          <Button bsStyle="default" onClick={() => this.props.callback(false, false)}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}